import React, { Component,Fragment } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { connect } from 'react-redux';
import {
	BRANCH_ACCESS
} from '../../../constants/general';
import { fetchBranchGroups } from '../../../store/actions/branches/branchActions';
import { Debouncer } from '../../../utils/debouncer';

class SearchBranchGroupsSelect extends Component {

	constructor(props) {
		super(props);
	  this.state = {
			isLoading:false,
			openSearcher:true,
			selected:"",
			branchGroups: [],
      		placeholder:'Buscar Grupo de comercio',
		}
	}

	componentDidUpdate(prevProps){
		let newList = [];
		let { branchGroups, userHigherAccess, branchGroupsByIds=[] } = this.props;

		if ((prevProps.branchGroups  && prevProps.branchGroups.data && prevProps.branchGroups.data.length) !== (branchGroups.data && branchGroups.data.length) && userHigherAccess > BRANCH_ACCESS) {
      /* if(branchGroupsByIds.length > 0){
				newList = branchGroups.data.filter((objeto) =>
					branchGroupsByIds.some((id) => id.id === objeto.id)
				);
			} */
			newList = branchGroups.data.map(b => { return { access_id: b.id, related_access: b } })
      newList = newList.concat({access_id:-1,related_access: {id:-1,name:this.state.placeholder}})

			this.setState({ branchGroups: newList })
		}
		if(prevProps.selected !== this.props.selected){
			this.setState({ selected: this.props.selected })
		}
	}

	clearform(){
		this.setState({openSearcher:false})
		this._typeahead.getInstance().clear();
		this.props.clear ? this.props.clear() : null
	}

	debouncer = new Debouncer(500);

	SearchAction(query){
		this.setState({searchValue: query,isLoading: true, openSearcher:true})
		let { userHigherAccess } = this.props;
		if(userHigherAccess > BRANCH_ACCESS){
			this.debouncer.debounce(() => {
				this.props.fetchBranchGroups(1,query).then(() => {
					this.setState({ isLoading: false })
				})
				.catch((err) => {
					this.setState({ isLoading: false })
				})
			})
		}
	}

	changeAction = (selected) => {
		this.props.change(selected)
		this.props.dontClearInput ? null : this._typeahead.getInstance().clear();
	}

	render () {
		return (
			<Fragment>
				{this.props.fromReports ?
					<div className="d-flex">
						<div className={`custon_tap custon_active_tab`} onClick={()=> this.clearform()} style={{padding: `0 5px 0 0`,display:'flex', gap:'10px',alignItems: 'center',cursor:"pointer"}}>

							<span className='mx-2'>
								Todos
							</span>
						</div>
						<div style={{ width: "100%" }}>
							<AsyncTypeahead
								ref={(ref) => this._typeahead = ref}
								/*defaultSelected={this.props.branchGroupsByIds} */
								multiple={this.props.multiple}
								labelKey="name"
								options={ this.state.branchGroups.map($0 => $0.related_access)}
								onChange={this.changeAction}
								onSearch={(query) => this.SearchAction(query)}
								isLoading={this.state.isLoading}
								defaultInputValue={ this.props.selected }
								placeholder={this.state.placeholder}
							/>
						</div>
					</div>
					:
					<AsyncTypeahead
						ref={(ref) => this._typeahead = ref}
						/*defaultSelected={this.props.branchGroupsByIds} */
						multiple={this.props.multiple}
						labelKey="name"
						options={ this.state.branchGroups.map($0 => $0.related_access)}
						onChange={this.changeAction}
						onSearch={(query) => this.SearchAction(query)}
						isLoading={this.state.isLoading}
						defaultInputValue={ this.props.selected }
						placeholder={this.state.placeholder}
					/>
				}

			</Fragment>
		)
	}
}


const mapStateToProps = (state) => {
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.name,
		company:state.company,
		userHigherAccess: state.userHigherAccess,
		errors: state.errors,
		json_lang: state.json_lang,
		branchGroups:state.branchGroups
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchBranchGroups: (page,query) => dispatch(fetchBranchGroups(page,query)),
	}
}

export default connect(mapStateToProps , mapDispatchToProps)(SearchBranchGroupsSelect);



// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SearchBranchGroupsSelect.js